"use client";

import { useEffect, useState } from "react";
import {
  Carousel,
  type CarouselApi,
  CarouselContent,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { MultiDietReviewsCarouselItem } from "@/features/static-builder/components/multidiet-reviews-carousel";
import type { MultiDietReviewsType } from "@/features/static-builder/types/multidiet-reviews.type";
import { useCarouselDrag } from "@/lib/hooks/use-carousel-drag";

export const MultiDietReviewsCarousel = ({
  data,
  strapiUrl,
}: {
  data: MultiDietReviewsType;
  strapiUrl: string[];
}) => {
  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);

  const isDragging = useCarouselDrag(api);

  useEffect(() => {
    if (!api) {
      return;
    }
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap());

    api.on("select", () => {
      setCurrent(api.selectedScrollSnap());
    });
  }, [api]);
  return (
    <div className="space-y-8 md:space-y-16">
      {data.title && (
        <h2 className="z-[1] font-medium text-3.5xl text-brand-green2-300 leading-8 lg:text-5xl lg:leading-14">
          {data.title}
        </h2>
      )}
      <Carousel
        className="relative"
        opts={{ dragFree: true, slidesToScroll: 3, align: "start" }}
        setApi={setApi}
      >
        <CarouselContent className="space-x-4">
          {data.reviews.map((item, index) => (
            <MultiDietReviewsCarouselItem
              key={item.id}
              review={item}
              strapiUrl={strapiUrl[index] ?? ""}
            />
          ))}
        </CarouselContent>
        {current !== 0 && (
          <div className="pointer-events-none absolute top-0 left-0 hidden h-full w-36 bg-gradient-to-r from-brand-white to-transparent lg:block" />
        )}
        {current + 1 !== count && (
          <div className="pointer-events-none absolute top-0 right-0 hidden h-full w-36 bg-gradient-to-l from-brand-white to-transparent lg:block" />
        )}
        {!isDragging && (
          <>
            <CarouselNext className="right-2 h-14 w-14 rounded-xl border border-brand-grey2 bg-brand-white text-brand-green2-300 disabled:hidden" />
            <CarouselPrevious className="left-2 h-14 w-14 rounded-xl border border-brand-grey2 bg-brand-white text-brand-green2-300 disabled:hidden" />
          </>
        )}
      </Carousel>
    </div>
  );
};
